import React from 'react'
import PropTypes from 'prop-types'
import { pluralize } from '../../../utils/textHelpers'

const HEADER_BASE = 'tw:flex tw:items-center tw:justify-between tw:gap-3 tw:w-full tw:px-4 tw:py-3'
  + ' tw:border tw:border-solid tw:border-gray-300 tw:text-left'
const HEADER_OPEN = `${HEADER_BASE} tw:bg-gray-100 tw:rounded-t-md!`
const HEADER_CLOSED = `${HEADER_BASE} tw:bg-white tw:rounded-md!`

const BODY = 'tw:flex tw:flex-col tw:gap-4 tw:border tw:border-t-0 tw:border-solid tw:border-gray-300'
  + ' tw:rounded-b-md! tw:p-4'

const BADGE_BASE = 'tw:inline-block tw:whitespace-nowrap tw:rounded-md! tw:px-1.5 tw:py-0.5'
  + ' tw:text-xs tw:font-medium'
const BADGE_OPEN = `${BADGE_BASE} tw:bg-gray-200 tw:text-gray-900`
const BADGE_CLOSED = `${BADGE_BASE} tw:bg-gray-100 tw:text-gray-700`

const NAME_CLASS = 'tw:flex-1 tw:min-w-0 tw:text-sm tw:font-normal tw:text-gray-900 tw:break-words'
const SIDE_CLASS = 'tw:flex tw:items-center tw:gap-3 tw:shrink-0'
const CHEVRON_CLASS = 'tw:shrink-0 tw:text-xs tw:text-gray-700'

const SectionGroup = ({ name, count, isOpen, onToggle, collapsible, children }) => {
  const chevron = `fas fa-chevron-${isOpen ? 'up' : 'down'} ${CHEVRON_CLASS}`
  const headerClass = isOpen ? HEADER_OPEN : HEADER_CLOSED
  const badgeClass = isOpen ? BADGE_OPEN : BADGE_CLOSED
  const label = (
    <>
      <span className={NAME_CLASS}>{`Section : ${name}`}</span>
      <span className={SIDE_CLASS}>
        <span className={badgeClass}>{pluralize(count, 'condition')}</span>
        {collapsible ? <i aria-hidden="true" className={chevron} /> : null}
      </span>
    </>
  )

  return (
    <div className="tw:shrink-0">
      {collapsible ? (
        <button
          aria-expanded={isOpen}
          className={`${headerClass} tw:cursor-pointer`}
          type="button"
          onClick={onToggle}
        >
          {label}
        </button>
      ) : <div className={headerClass}>{label}</div>}
      {isOpen ? <div className={BODY}>{children}</div> : null}
    </div>
  )
}

SectionGroup.propTypes = {
  children: PropTypes.node.isRequired,
  collapsible: PropTypes.bool,
  count: PropTypes.number.isRequired,
  isOpen: PropTypes.bool.isRequired,
  name: PropTypes.string.isRequired,
  onToggle: PropTypes.func
}

SectionGroup.defaultProps = {
  collapsible: true,
  onToggle: null
}

export default SectionGroup
